import CompanyLogo from '~components/CompanyLogo';
import * as S from '~features/company/Header/style';
import { useSuspensedCompanyInfo } from '~hooks/query/company/useCompanyInfo';
import { useSuspensedCompanyStates } from '~hooks/query/company/useCompanyStates';

import ActionButton from './ActionButton';
import CompanyDescription from './CompanyDescription';

function CompanyInfo() {
  const { data: companyInfo } = useSuspensedCompanyInfo();
  const { data: companyStates } = useSuspensedCompanyStates();

  return (
    <>
      <CompanyLogo PK_NM_HASH={companyInfo?.PK_NM_HASH} logoCss={S.logoCss} />
      <CompanyDescription companyInfo={companyInfo} companyStates={companyStates} />
      <ActionButton companyInfo={companyInfo} />
    </>
  );
}

export default CompanyInfo;
